import DefaultAvatar from "./defaultAvatar.png";
import DefaultCustomer from "./defaultCustomer.png";
import Logo from "./Logo.png";
import CustomerImg from "./customerImg.png";

const Images = {
  DefaultAvatar,
  DefaultCustomer,
  Logo,
  CustomerImg,
};

export { Images };
